<template>
    <div
            ref="photo"
            class="background-image-placement"
            v-bind:style="{'background-image': `url(${src})`}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'FotoCuadrada',

        props: ['src', 'factor'],

        methods: {
            resize() {
                const photo = this.$refs.photo;
                if (!photo) return;
                photo.style.height = `${photo.clientWidth / this.factor}px`;
            },
        },

        mounted() {
            window.addEventListener('resize', this.resize);
            this.resize();
        },

        unmounted() {
            window.removeEventListener('resize', this.resize);
        },
    };
</script>